/**
 * 日付入力パーツ
 */
<template>
	<div>
		<el-date-picker
			ref="refdata"
			:value="m_date"
			:type="r_type"
			:class="r_class"
			clear-button-icon="fa fa-calendar"
			:clearable="r_clearable"
			:format="getPickerFormat()"
			:value-format="'yyyy/MM/dd'"
			:picker-options="m_pickerOptions"
			:readonly="r_readonly"
			:disabled="r_readonly"
			:editable="false"
			@blur="onBlur"
			@focus="onFocus"
			@input="setDatetime">
		</el-date-picker>
	</div>
</template>

<script>
	import lang_ja from 'element-ui/lib/locale/lang/ja';
	import lang_en from 'element-ui/lib/locale/lang/en';
	import element_locale from 'element-ui/lib/locale';
	export default {
		props: {
			value: {},
			r_type: {
				type: String,
				default: 'date'
			},
			r_class: {},
			r_messages: {},
			r_settings: {},
			// 日付のクリアボタンがあるか
			r_clearable: {
				type: Boolean,
				default: false
			},
			r_format: {
				type: String,
				default: 'yyyy-MM-dd'
			},
			// カレンダーの選択肢
			r_picker_options: {},
			r_picker_option_type: {
				type: Number,
				default: 1
			},
			r_picker_option_disabled: {
				type:String,
				default: '',
			},
			r_readonly: {
				default: false
			},
			r_date_disp_cl: {
				type: Number,
				default: 0,
			},
		},
		data: function (){
			return{
				m_date: this.value,
			}
		},
		created: function() {
			console.log(this.r_settings);
			if (this.r_settings.user.language == 'Japanese') {
				element_locale.use(lang_ja);
			} else {
				element_locale.use(lang_en);
			}
		},
		computed: {
			v_data: function (){
				return this.$refs.refdata;
			},
			m_pickerOptions: function (){
				var target = this;
				if (this.r_picker_options) {
					return this.r_picker_options;
				}
				if (this.r_picker_option_type == 12) {
					// 未来（今日を除く）
					return {
						shortcuts: [
						{
							text: '明日',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24);
								picker.$emit('pick', date);
							}
						}, 
						{
							text: '1週間後',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
								picker.$emit('pick', date);
							}
						}],
						disabledDate(date) {
							if (target.r_picker_option_disabled == 'future') {
								return date > Date.now();
							} else {
								return;
							}
						},
					};
				}
				if (this.r_picker_option_type == 2) {
					// 未来（今日を含む）
					return {
						shortcuts: [
						{
							text: (this.r_settings.user.language == 'Japanese') ? '今日' : 'Today',
							onClick(picker) {
								picker.$emit('pick', new Date());
							}
						}, 
						{
							text: (this.r_settings.user.language == 'Japanese') ? '明日' : 'Tomorrow',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24);
								picker.$emit('pick', date);
							}
						}, 
						{
							text: (this.r_settings.user.language == 'Japanese') ? '1週間後' : 'In a week',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
								picker.$emit('pick', date);
							}
						}],
						disabledDate(date) {
							if (target.r_picker_option_disabled == 'future') {
								return date > Date.now();
							} else {
								return;
							}
						},
					};
				}
				if (this.r_picker_option_type == 1) {
					// 過去
					return {
						shortcuts: [{
							text: (this.r_settings.user.language == 'Japanese') ? '今日' : 'Today',
							onClick(picker) {
								picker.$emit('pick', new Date());
							}
						}, {
							text: (this.r_settings.user.language == 'Japanese') ? '昨日' : 'Yesterday',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24);
								picker.$emit('pick', date);
							}
						}, {
							text: (this.r_settings.user.language == 'Japanese') ? '1週間前' : 'One week ago',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit('pick', date);
							}
						}],
						disabledDate(date) {
							if (target.r_picker_option_disabled == 'future') {
								return date > Date.now();
							} else {
								return;
							}
						},
					};
				}
				return {};
			},
		},
		watch: {
			value: function (val){
				this.m_date = val;
			}
		},
		mounted:function(){
		},
		methods: {
			getPickerFormat: function() {
				var result = '';
				if (this.r_date_disp_cl == 1) {
					result = 'dd/MM/yyyy';
				} else	if (this.r_date_disp_cl == 2) {
					result = 'yyyy/MM/dd';
				} else {
					result = 'MM/dd/yyyy';
				}
				return result;
			},
			setDatetime: function(date) {
				// ×ボタンが押された時もこのメソッドが呼ばれる
				if ( date != this.m_date ) {
					if ( date ) {
						this.$emit('input', date);
					} else {
						this.$emit('input', "");
						if (this.r_clearable) {
							this.$emit('blur', null);
						}
					}
				}
			},
			onBlur: function(e) {
				if(e.userInput != null){
					e.userInput = this.m_date;
				}
				this.$emit('blur', e);
			},
			onFocus: function(e){
				this.$emit('focus', e);
			},
			setClear: function(){
				this.$refs.refdata.userInput = "";
			},
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/inputCalendar.vue